import { render } from "./LayoutUpload.vue?vue&type=template&id=b47689b4"
import script from "./LayoutUpload.vue?vue&type=script&lang=js"
export * from "./LayoutUpload.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__